import { render, staticRenderFns } from "./LocalizationFileForm.vue?vue&type=template&id=031fa079&"
import script from "./LocalizationFileForm.vue?vue&type=script&lang=js&"
export * from "./LocalizationFileForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports